export default {
    data () {
        return {
            fromRoute: null
        }
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.fromRoute = from;
        })
    },

    methods: {
        /**
         * Handle Back
         * @desc Extends default router back functionality
         * @param {string} fallback - The fallback path if there is no history to use with $router.back(). This is usually the case if the page was visited directly or from another site
         **/
        handleBack (fallback, forceFallback = false, parameters = {}) {
            console.log("handleBack: ", fallback, forceFallback, parameters);
            //if ((this.fromRoute == null || !this.fromRoute.hasOwnProperty('name')) || forceFallback === true) {
            if (fallback != "" && (this.fromRoute == null || forceFallback === true)) {
                console.log("router fallback", fallback, parameters);
                if(fallback == undefined){
                    fallback = "dashboard";
                }
                this.$router.push({name: fallback, params: parameters});
            } else {
                console.log("router back");
                this.$router.back();
            }
        }
    }
};
